import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getAllNotes } from "./NoteService";


export default function NoteList(){
const [notes,setNotes] = useState([]);
const nav = useNavigate();


useEffect(()=>{ load(); },[]);


const load = async ()=>{
const data = await getAllNotes();
setNotes(data);
};


return (
<div style={wrap}>
<div style={header}>
<h2>Notes</h2>
<button onClick={()=>nav("new")}>➕ New Note</button>
</div>


<div style={grid}>
{notes.map(n=> (
<div key={n.id} style={card}>
<div style={title}>{n.title}</div>
<div style={body}>{n.content}</div>
<div style={meta}>{n.createdDate}</div>
</div>
))}
</div>
</div>
);
}


const wrap={ padding:"20px" };
const header={ display:"flex", justifyContent:"space-between", alignItems:"center" };
const grid={ display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(260px,1fr))", gap:"16px" };
const card={ background:"#fff", padding:"16px", borderRadius:"14px", boxShadow:"0 6px 16px rgba(0,0,0,0.08)" };
const title={ fontWeight:"600" };
const body={ fontSize:"14px", marginTop:"6px" };
const meta={ fontSize:"11px", color:"#888", marginTop:"10px" };